import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { get, map, orderBy, isEmpty, filter } from "lodash";
import { RichText } from "prismic-reactjs";
import StoreCard from "../components/StoreCard";

const StlSection = styled.section`
  width: 100%;
  max-width: 1200px;
  padding: 5%;
  margin: auto;
`;

const StlHeadlineWrapper = styled.div`
  text-align: center;
  margin: 20px auto 30px;
`;

const StlStoreList = styled.ul`
  display: grid;
  gap: 20px;
  list-style-type: none;
  @media (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
  }
`;

const StlFilter = styled.div`
  display: flex;
  justify-content: center;
  gap: 45px;
  margin-bottom: 55px;
  button {
    border: none;
    background: none;
    text-transform: uppercase;
  }
`;

const StoresSlice = (slice) => {
  const storesObj = get(slice, "items");
  const sortedStores = orderBy(
    storesObj,
    (store) => get(store, "store_name[0].text", ""),
    "asc"
  );
  const [stores, setStores] = useState(sortedStores);
  const url = useMemo(() => new URL(window.location.href), []);
  const medStores = filter(sortedStores, (el) => el?.is_medical === true);
  const recStores = filter(sortedStores, (el) => el?.is_recreational === true);
  const medAndRec = !isEmpty(medStores) && !isEmpty(recStores);
  const medOnly = !isEmpty(medStores) && isEmpty(recStores);
  const recOnly = isEmpty(medStores) && !isEmpty(recStores);
  const urlUsageType = medOnly ? "med" : recOnly ? "rec" : "all";

  const addParams = (usageType) => {
    const params = url.searchParams;
    params.set("usage", usageType);
    url.search = params.toString();
    window.history.pushState({}, "", url);
  };

  const setParamSetStore = (param, storeObj) => {
    url.search = "";
    addParams(param);
    setStores(storeObj);
  };

  const medClick = () => {
    setParamSetStore("med", medStores);
  };

  const recClick = () => {
    setParamSetStore("rec", recStores);
  };

  const allClick = () => {
    setParamSetStore("all", sortedStores);
  };

  useEffect(() => {
    const usage = url.searchParams.get("usage");
    if (usage === "med") setStores(medStores);
    else if (usage === "rec") setStores(recStores);
    else {
      addParams(urlUsageType);
      setStores(sortedStores);
    }
  }, []);

  if (isEmpty(storesObj)) return null;

  return (
    <StlSection>
      <StlHeadlineWrapper>
        <RichText render={get(slice, "primary.headline_text")} />
      </StlHeadlineWrapper>
      <StlFilter>
        {medAndRec && (
          <>
            <button className="filter-btn" onClick={allClick}>
              All
            </button>
            <button className="filter-btn" onClick={medClick}>
              Medical Use
            </button>
            <button className="filter-btn" onClick={recClick}>
              Adult Use
            </button>
          </>
        )}
        {medOnly && <div className="filter-btn">Medical Use</div>}
        {recOnly && <div className="filter-btn">Adult Use</div>}
      </StlFilter>

      <StlStoreList>
        {map(stores, (item, index) => (
          <li key={index}>
            <StoreCard
              src={get(item, "image.url")}
              alt={get(item, "image.alt")}
              copy={item?.store_name}
              link={get(item, "store_url.url")}
            />
          </li>
        ))}
      </StlStoreList>
    </StlSection>
  );
};

export default StoresSlice;
